/*
  The site footer's script, sections/mm-footer.liquid (2026-10-28).

  Columns: open on a computer, folded on a phone (open in the markup, so they read without it).
  The signup is assets/mm-signup.js, shared with the newsletter page.
  Started on load and on shopify:section:load, so the theme editor's redraw keeps it working.
*/
(function () {
  if (window.mmFooter) {
    window.mmFooter.start(document);
    return;
  }

  var phone = window.matchMedia('(max-width: 749px)');

  function start(root) {
    root.querySelectorAll('[data-mm-fold]').forEach(function (d) {
      if (phone.matches) d.removeAttribute('open');
      else d.setAttribute('open', '');
    });
  }

  window.mmFooter = { start: start };
  phone.addEventListener('change', function () { start(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
